<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div v-if="category">
      <b-card>

        <b-form>
          <b-row>

            <b-col
                class="mb-1"
                cols="12"
            >
              <h3>ویرایش دسته بندی</h3>
            </b-col>

            <b-col cols="12">
              <!-- Media -->
              <b-media class="my-2">
                <template >
                  <b-avatar
                      ref="previewEl"
                      :src="base64ImageSrc"
                      size="300px"
                      rounded
                  />
                </template>
                <div class="d-flex flex-wrap mt-1">
                  <b-button
                      variant="primary"
                      @click="$refs.refInputEl.click()"
                  >
                    <input
                        ref="refInputEl"
                        type="file"
                        class="d-none"
                        @input="makeBase64Pic"
                    >
                    <span class="d-none d-sm-inline">ویراش عکس</span>
                    <feather-icon
                        icon="EditIcon"
                        class="d-inline d-sm-none"
                    />
                  </b-button>
<!--                  <b-button-->
<!--                      variant="outline-secondary"-->
<!--                      class="ml-1"-->
<!--                      @click="deleteProductPic()"-->
<!--                  >-->
<!--                    <span class="d-none d-sm-inline">حذف</span>-->
<!--                    <feather-icon-->
<!--                        icon="TrashIcon"-->
<!--                        class="d-inline d-sm-none"-->
<!--                    />-->
<!--                  </b-button>-->
                </div>
              </b-media>
            </b-col>

            <!-- Field: name -->
            <b-col
                cols="12"
                md="4"
            >
              <b-form-group
                  label-for="name"
              >
                <b-form-input
                    id="name"
                    v-model="category.name"
                />
              </b-form-group>
            </b-col>

            <b-col class="my-1" cols="12">
              <span>توضیحات :</span>
              <ckEditorMain ref="editorContent" :defaultContent="category.description"
                            @getEditorContent="setEditorContent"></ckEditorMain>
            </b-col>
          </b-row>
        </b-form>

        <!-- Action Buttons -->
        <b-button
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            class="mt-1 mb-sm-0 mr-0 mr-sm-1"
            variant="primary"
            @click="updateCategory"
        >
          ذخیره تغییرات
        </b-button>

      </b-card>

      <!-- modal vertical center -->
      <b-modal
          v-if="updateCategoryPropertyData !== null"
          id="modal-center"
          centered
          ok-only
          ok-title="ثبت"
          title="ویرایش خصوصیت"
          @ok="updateCategoryProperty"

      >
        <b-form-group
            invalid-feedback="Name is required"
            label="Name"
            label-for="name-input"
        >
          <b-form-input
              id="name-input"
              v-model="updateCategoryPropertyData.name"
              required
          />
        </b-form-group>
      </b-modal>
      <!-- modal vertical center -->
    </div>
  </b-overlay>
</template>

<script>
import {
  ProductCategoryGetRequest,
  ProductCategoryPropertyCreateRequest,
  ProductCategoryPropertyDeleteRequest,
  ProductCategoryPropertyGetByCategoryIdRequest,
  ProductCategoryPropertyUpdateRequest,
  ProductCategoryUpdateRequest
} from "@/libs/Api/Product";
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput, BMedia,
  BModal,
  BOverlay,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import ckEditorMain from "@/views/components/ckEditorMain";
import Helper from "@/libs/Helper";

export default {
  title: "ویرایش دسته بندی - پنل ادمین نهایی شو",
  name: "categories-edit",
  data() {
    return {
      category: null,
      showOverlay: false,
      categoryProperties: null,
      base64ImageSrc:null,
      deleteItem: null,
      categoryId: this.$route.params.id,
      addNewCategoryProperty: false,
      myTableColumns: [
        {key: 'categoryPropertyId', label: 'شناسه'},
        {key: 'name', label: 'نام'},
        {key: 'delete', label: 'حذف'},
        {key: 'edit', label: 'ویرایش'},
      ],
      defaultCreateCategoryPropertyData: {
        isDeleted: false,
        categoryPropertyId: 0,
        categoryId: this.$route.params.id,
        name: ""
      },
      updateCategoryPropertyData: null,
    }
  },
  async created() {
    await this.getCategory();
  },
  methods: {
    async getCategory() {
      let _this = this;
      _this.showOverlay = true;

      let productCategoryGetRequest = new ProductCategoryGetRequest(_this);
      productCategoryGetRequest.setId(_this.categoryId);
      await productCategoryGetRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.category = content;
        _this.base64ImageSrc = Helper.baseUrl+_this.category.image;
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    async makeBase64Pic(e){
      const _this = this;
      let file = e.target.files[0];
      _this.base64ImageSrc = URL.createObjectURL(file);
    },
    async updateCategory() {
      let _this = this;
      _this.showOverlay = true;

      let formData = new FormData;
      let upFile = _this.$refs.refInputEl.files[0];
      formData.append('ProductCategoryId', _this.category.productCategoryId);
      formData.append('Name', _this.category.name);
      formData.append('Description', _this.category.description);
      formData.append('IsCourse', _this.category.isCourse);
      formData.append('IsDeleted', _this.category.isDeleted);
      formData.append('PicFile', upFile);

      let productCategoryUpdateRequest = new ProductCategoryUpdateRequest(_this);
      productCategoryUpdateRequest.setParams(formData);
      await productCategoryUpdateRequest.sendFormData(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `تغییرات اعمال شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    async createProductCategoryProperty() {
      let _this = this;

      let productCategoryPropertyCreateRequest = new ProductCategoryPropertyCreateRequest(_this);
      productCategoryPropertyCreateRequest.setParams(_this.defaultCreateCategoryPropertyData);
      await productCategoryPropertyCreateRequest.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `دسته بندی جدید اضافه شد.`,
          },
        })
        _this.getCategoryProperty();
      }, function (error) {
        console.log(error)
      })
    },
    async deleteCategoryProperty(param) {
      let _this = this;

      let productCategoryPropertyDeleteRequest = new ProductCategoryPropertyDeleteRequest(_this);
      productCategoryPropertyDeleteRequest.setId(param);
      await productCategoryPropertyDeleteRequest.fetch(function (content) {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `دسته بندی جدید حذف شد.`,
          },
        })
        _this.getCategoryProperty();
      }, function (error) {
        console.log(error)
      })
    },
    async updateCategoryProperty() {
      let _this = this;
      _this.showOverlay = true;

      let productCategoryPropertyUpdateRequest = new ProductCategoryPropertyUpdateRequest(_this);
      productCategoryPropertyUpdateRequest.setParams(_this.updateCategoryPropertyData);
      await productCategoryPropertyUpdateRequest.fetch(function (content) {
        _this.showOverlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `دسته بندی جدید اضافه شد.`,
          },
        })
        _this.getCategoryProperty();
      }, function (error) {
        _this.showOverlay = false;
      })
    },
    setUpdateCategoryPropertyData(param) {
      this.updateCategoryPropertyData = param;
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    setEditorContent(content) {
      this.category.description = content
    },
  },
  components: {
    BAvatar, BMedia,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BFormGroup,
    BForm,
    BModal,
    ckEditorMain,
    vSelect,
  }
}
</script>

<style scoped>

</style>